import "./contact.styles.scss";

const Contact = () => {
  return (
    <div className="contact-page-container">
      <h1>Contact Us</h1>
      <p>This is a contact page</p>
    </div>
  );
}

export default Contact;